export interface ScrollPos {
    x:number,
    y:number
}



export class ScrollHistory {

    private history:{[key:string]:ScrollPos} = {};
    target:Window | Element = window;

    constructor() {
        // make sure only we controll scroll pos.
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
    }

    getPos( key:string ) {
        let t = this.target;
        this.history[ key ] = ( t instanceof Window ) ? { x:t.scrollX, y:t.scrollY }  : { x:t.scrollLeft, y:t.scrollTop };
    }

    setPos( key, restore:boolean = false ) {
        let pos = ( restore && this.history[ key ] ) ? this.history[ key ] : { x:0, y:0 };
        this.target.scrollTo( pos.x, pos.y );
    }

}
